<template>
  <el-dialog
    :title="title"
    :visible.sync="studentDialog.show"
    v-if="studentDialog.show"
    :close-on-click-modal="false"
    width="1100px"
  >
    <div class="main-contant">
      <div class="left-tree">
        <DeptTree @select="select" :classId="classId" :type="type" showTooltip/>
      </div>
      <div class="right-table">
        <div class="top-filter">
          <el-select
            class="select_btn_style filter-item"
            v-model="filters.leaderTypeMore"
            placeholder="管理主体(多选)"
            size="small"
            multiple
            collapse-tags
          >
            <el-option
              v-for="(item, i) in manageSubjects"
              :key="i"
              :label="item.paramValue"
              :value="item.paramKey"
            ></el-option>
          </el-select>
          <el-select class="select_btn_style filter-item" v-model="filters.cadreLevels" placeholder="干部级别(多选)"
            size="small" multiple collapse-tags>
            <el-option v-for="(item, i) in cadreLevelData" :key="i" :label="item.paramValue" :value="item.paramKey">
            </el-option>
          </el-select>
          <el-select
            class="select_btn_style filter-item"
            v-model="filters.userStatus"
            placeholder="用户状态"
            size="small"
          >
            <el-option
              v-for="(item, i) in statusList"
              :key="i"
              :label="item.paramValue"
              :value="item.paramKey"
            ></el-option>
          </el-select>
          <el-select
            size="small"
            class="select_btn_style filter-item"
            v-model="filters.isExam"
            placeholder="考核状态"
          >
            <el-option
              v-for="(item, i) in publicData"
              :key="i"
              :label="item.paramValue"
              :value="item.paramKey"
            ></el-option>
          </el-select>
          <!-- supremeLeader：一把手(TYPE: SUPREME_LEADER 0:党委一把手 1:政府一把手 2:两者皆有) -->
          <el-checkbox
            border
            v-model="partOne"
            size="small"
            class="filter-item-statu"
            @change="queryClick"
            >党委一把手</el-checkbox
          >
          <el-checkbox
            border
            v-model="goverOne"
            size="small"
            class="filter-item-statu"
            @change="queryClick"
            >政府一把手</el-checkbox
          >
          <el-input
            v-model="name"
            placeholder="请输入名字"
            size="small"
            class="name-input"
          ></el-input>
          <butn btntype="primary" @click="queryClick()" title="查询"></butn>
          <butn class="czButn" @click="resetClick()" title="重置"></butn>
        </div>
        <el-table
          v-if="!isOnlyOne"
          ref="pageListTable"
          border
          :data="tableData"
          :row-style="{ color: '#51627D', fontWeight: 400 }"
          :header-row-style="{ color: '#343C4A', fontWeight: 500 }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40" :selectable="isDisable">
          </el-table-column>
          <el-table-column
            prop="className"
            label="所在班级"
            show-overflow-tooltip
            width="150"
            v-if="
              classId &&
                $route.query.trainTypeName &&
                $route.query.trainTypeName === '轮训班'
            "
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.className ? scope.row.className : "--"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="姓名"
            show-overflow-tooltip
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="deptName"
            label="单位"
            show-overflow-tooltip
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="unitPosition"
            label="单位及职务"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <el-table
          v-else
          ref="pageListTable"
          :data="tableData"
          border
          :row-style="{ color: '#51627D', fontWeight: 400 }"
          :header-row-style="{ color: '#343C4A', fontWeight: 500 }"
          @current-change="clickChange"
        >
          <el-table-column label="" width="40">
            <template slot-scope="scope">
              <el-radio v-model="tableRadio" :label="scope.row"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="userName"
            label="姓名"
            show-overflow-tooltip
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="deptName"
            label="单位"
            show-overflow-tooltip
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="unitPosition"
            label="单位及职务"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="sizeChange"
          @current-change="pageChange"
          :current-page="currentPage"
          :page-size="size"
          :page-sizes="[10, 50, 100, 500, 1000]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          hide-on-single-page
        />
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <butn btntype="primary" @click.native="submit()" title="确定"></butn>
      <butn class="czButn" @click.native="cancel()" title="取消"></butn>
    </div>
  </el-dialog>
</template>

<script>
import DeptTree from "@/components/tree/deptLazyTree.vue";
import { pageByDepts } from "@/api/user";
import {
  saveStudent,
  getStudentList,
  saveEnroll,
  getEnrollList,
  getEnrolledList,
} from "@/api/enrollment";
import { saveStudent as saveOfflineStudent } from "@/api/enrollOffline";
import { getEnums, clearObject } from "@/utils/common.js";

import { getExamUser, saveExamUser } from "@/api/examInfo";
import {
  investigationUserSave,
  investigationUserPage,
} from "@/api/investigation";
import { checkRewardUsers } from "@/api/rewardPunish";
import butn from "@/components/button/index";

export default {
  name: "selectStudents",
  components: {
    DeptTree,
    butn,
  },
  props: {
    type: {
      type: Number,
      default: 1,
    },
    studentDialog: {
      type: Object,
      default: () => {
        return {
          show: false,
        };
      },
    },
    classId: {
      type: String,
      default: () => "",
    },
    isClass: {
      type: Boolean,
      default: () => true,
    },
    isOnlyOne: {
      type: Boolean,
      default: () => false,
    },
    onlyId: {
      type: String,
      default: () => "",
    },
    isExam: {
      type: Boolean,
      default: () => false,
    },
    examId: {
      type: String,
      default: () => "",
    },
    isInvestigation: {
      type: Boolean,
      default: () => false,
    },
    needDisable: {
      type: Boolean,
      default: () => false,
    },
    isEnrollment: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: () => "添加学员",
    },
    isOffline: {
      type: Boolean,
      default: () => false,
    },
    isRewardPunish: {
      type: Boolean,
      default: () => false,
    },
    defaultInfo: undefined,
  },
  data() {
    return {
      partOne: false,
      goverOne: false,
      manageSubjects: [],
      statusList: [],
      publicData: [],
      filters: {
        supremeLeader: "",
        classId: "", //
        leaderTypeMore: [],
        userStatus: null,
        isExam: null
      },
      blockString: "",
      tableData: [],
      rows: [],
      name: "",
      deptLevelCodes: null,
      total: 0,
      currentPage: 1,
      size: 10,
      userIdList: new Set(),
      // userNameList: new Set(),
      idValueMap: {},
      nowPageIds: [],
      hasIds: [],
      tableRadio: null,
      notSetIds: [],
      cadreLevelData: [],
    };
  },
  mounted() {
    if (this.isClass) {
      getStudentList(this.classId).then(({ code, data }) => {
        if (code !== 0) return;        
        this.hasIds = data.map((x) => x.userId);
        this.hasIds.forEach((x) => {
          this.userIdList.add(x);
        });
      });
    }
    if (this.isExam) {
    }
    if (this.isInvestigation) {
      investigationUserPage({
        investigationId: this.examId,
        limit: 1000,
        page: 1,
      }).then(({ code, data }) => {
        if (code !== 0) return;
        this.hasIds = data.records.map((x) => x.userId);
        this.hasIds.forEach((x) => {
          this.userIdList.add(x);
        });
      });
    }
    if (this.isEnrollment) {
      getEnrollList(this.classId).then(({ code, data }) => {
        if (code !== 0) return;
        this.hasIds = data;
        this.hasIds.forEach((x) => {
          this.userIdList.add(x);
        });
      });
      getEnrolledList(this.classId).then((res) => {
        if (!res || res.code != 0) return;
        this.notSetIds = res.data;
      });
    }
    if (
      this.defaultInfo &&
      Object.keys(this.defaultInfo.idValueMap).length > 0
    ) {
      this.idValueMap = { ...this.defaultInfo.idValueMap };
      this.userIdList = new Set();
      Object.keys(this.defaultInfo.idValueMap).map((o) => {
        this.userIdList.add(o);
      });
    }
  },
  created() {
    getEnums(
      ["USER_LEADER_TYPE", "USER_STATUS", "EXAM_STATUS", "CADRE_LEVEL"],
      this,
      ["manageSubjects", "statusList", "publicData", "cadreLevelData"],
      [true, true, true, false]
    );
  },
  computed: {
    supremeLeader() {
      if (this.partOne && this.goverOne) return "2";
      if (this.partOne && !this.goverOne) return "0";
      if (!this.partOne && this.goverOne) return "1";
      return "";
    },
  },
  methods: {
    isDisable(row) {
      if (this.needDisable) {
        if (this.isOffline) {
          return !this.hasIds.includes(row.uuid);
        } else {
          let selectIds = this.rows.map((v) => {
            return v.uuid;
          });
          return (
            !this.notSetIds.includes(row.uuid) && !selectIds.includes(row.uuid)
          );
        }
      } else {
        return true;
      }
    },
    clickChange(item) {
      this.tableRadio = item;
    },
    resetClick() {
      this.name = "";
      this.filters = {
        supremeLeader: "",
        classId: "", //
        leaderTypeMore: [],
        userStatus: "",
      };
      this.partOne = false;
      this.goverOne = false;
      this.queryClick();
    },
    queryClick() {
      if (this.deptLevelCodes) {
        this.currentPage = 1;
        this.getList();
      } else {
        this.$message.warning("请先选择部门或学院！");
      }
    },
    submit() {
      if (this.isClass) {
        if (this.isOffline) {
          saveOfflineStudent({
            classId: this.classId,
            userIdList: Array.from(this.userIdList),
          }).then(({ code, data }) => {
            if (code !== 0) return;
            this.$emit("closeSelect", true);
          });
        } else {
          saveStudent({
            classId: this.classId,
            userIdList: Array.from(this.userIdList),
          }).then(({ code, data }) => {
            if (code !== 0) return;
            this.$emit("closeSelect", true);
          });
        }
      }
      if (this.isRewardPunish) {
        if (this.defaultInfo.addType == 0) {
          let params = {
            userIds: Array.from(this.userIdList),
            year: this.defaultInfo.year,
          };
          checkRewardUsers(params).then((res) => {
            if (res && res.code == 0 && res.data) {
              let message = "";
              let flag = res.data.nameStr && res.data.nameStr.length > 0;
              if (flag) {
                let arr = [res.data.nameStr];
                if (res.data.isForce) {
                  arr.push(
                    "一个用户一年只能添加 1 次奖励学分，以上用户当前年度已经有奖励记录，不能再次添加！"
                  );
                } else {
                  arr.push(
                    "一个用户建议一年添加 1 次奖励学分，确定要添加选中学员吗？"
                  );
                }
                message = arr.join(" <br/> ");
              } else {
                if (res.data.isForce) {
                  message =
                    "一个用户一年只能添加 1 次奖励学分，确定要添加选中学员吗";
                } else {
                  message =
                    "一个用户建议一年添加 1 次奖励学分，确定要添加选中学员吗？";
                }
              }
              this.$confirm(message, "系统提示", {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  if (!flag || !res.data.isForce) {
                    this.$emit("closeSelect", this.idValueMap);
                  }
                })
                .catch(() => {});
            }
          });
        } else if (this.defaultInfo.addType == 1) {
          this.$emit("closeSelect", this.idValueMap);
        }
      }
      if (this.isExam) {
        saveExamUser({
          examId: this.examId,
          userIdList: Array.from(this.userIdList),
        }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "新增成功",
            type: "success",
          });
          this.$emit("closeSelect");
        });
      }
      if (this.isInvestigation) {
        investigationUserSave({
          investigationId: this.examId,
          userIdList: Array.from(this.userIdList),
        }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "新增成功",
            type: "success",
          });
          this.$emit("closeSelect", true);
        });
      }
      if (this.isEnrollment) {
        const addUsers = this.dealArray();
        if ( addUsers.length === 0 ) {
          this.$message.warning('您还没有选择报名学员，请先选择要报名的学员');
          return;
        }
        saveEnroll({
          classId: this.classId,
          userIdList: addUsers,
        }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "新增成功",
            type: "success",
          });
          this.$emit("closeSelect", true);
        });
      }
    },
    dealArray() {
      let users = Array.from(this.userIdList);
      return users.filter(userId => !this.hasIds.includes(userId));
    },

    cancel() {
      this.$emit("closeSelect");
    },
    handleSelectionChange(val) {
      let temp = val.map((o) => o.uuid);
      let needDelUsers = this.tableData.filter(
        (val) => !temp.includes(val.uuid)
      );
      val.forEach((item) => {
        this.userIdList.add(item.uuid);
        this.idValueMap[item.uuid] = item.userName;
      });
      needDelUsers.forEach((item) => {
        this.userIdList.delete(item.uuid);
        delete this.idValueMap[item.uuid];
      });
    },
    select(obj) {
      this.currentPage = 1;
      this.deptLevelCodes = obj.deptLevelCodes;
      this.getList();
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    },
    sizeChange(size) {
      this.size = size;
      this.getList();
    },
    getList() {
      let params = clearObject({
        ...this.filters,
        deptLevelCodes: this.deptLevelCodes,
        page: this.currentPage,
        limit: this.size,
        name: this.name,
        classId: this.classId,
        supremeLeader: this.supremeLeader,
        leaderTypeMore: this.filters.leaderTypeMore,
      });
      pageByDepts(params).then(({ code, data }) => {
        if (code !== 0) return;
        let { records, total } = data;
        this.tableData = records;
        this.total = total;
        if (!this.isOnlyOne) {
          this.nowPageIds = this.tableData.map((x) => x.uuid);
          // let rows = [];
          this.nowPageIds.forEach((x, i) => {
            if (Array.from(this.userIdList).includes(x)) {
              this.rows.push(this.tableData[i]);
            }
          });
          setTimeout(() => {
            this.rows.forEach((row) => {
              this.$refs.pageListTable.toggleRowSelection(row, true);
            });
          }, 200);
        } else if (this.onlyId) {
          this.tableData.forEach((x) => {
            if (x.uuid == this.onlyId) {
              this.tableRadio = x;
            }
          });
        }
      });
    },
    closeFrom() {},
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table {
  max-height: 390px;
  overflow: auto;
}
/deep/ .el-dialog__body {
  padding: 20px;
  max-height: 1200px;
}
/deep/ .el-select__tags {
  height: 32px;
  overflow: hidden;
}
.main-contant {
  display: flex;
  min-height: 500px;
}
.left-tree {
  width: 235px;
  margin-right: 10px;
  max-height: 450px;
}
.right-table {
  flex: 1;
}
.top-filter {
  margin-bottom: 10px;
}
.filter-item {
  width: 180px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.filter-item-statu {
  width: 100px;
  margin-right: 10px;
}
.pagination {
  float: right;
}
.name-input {
  width: 180px;
  margin-right: 10px;
}
</style>
